import React from 'react'

type Props = {
  className: string
  imageSource: string
}

const FadedImage: React.FC<Props> = ({ className, imageSource }) => {
  return (
    <div className={`${className}-faded-image`}>
      <div
        className={`${className}-faded-image-src`}
        style={{
          backgroundImage: `url(${imageSource}?resize=1147x645&format=webp)`,
        }}
      ></div>
    </div>
  )
}

export default FadedImage
